export class SpreadsheetRecordFieldDto {
    constructor(public FieldName: string, public Value: string) {
    }
}